const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const contractsHost = publicConfig.external_address;

const Contracts = {

  readBookingContract: (bookingId, callback) => {
    const params = {
      host: contractsHost,
      method: 'GET',
      path: `/v1/contracts/contract/${bookingId}`
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  readContracts: (bookingId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'GET',
      path: `/v1/contracts/${bookingId}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  createOfferQuote: (payload, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: '/v1/contracts/offer/quote',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  createOffer: (payload, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: '/v1/contracts/offer',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  withdrawOffer: (control_id, payload, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${control_id}/offer/withdraw`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  acceptOffer: (payload, control_id, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${control_id}/offer/accept`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  declineOffer: (payload, control_id, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${control_id}/offer/decline`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  hostUpdateQuote: (payload, control_id, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${control_id}/update/host/quote`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  createHostUpdate: (payload, control_id, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${control_id}/update/host`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  withdrawHostUpdate: (payload, controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/update/host/withdraw`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  declineHostUpdate: (payload, controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/update/host/decline`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  acceptHostUpdate: (payload, controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/update/host/accept`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  readContractsSnapshot: (controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'GET',
      path: `/v1/contracts/${controlId}/snapshots`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  cancelBookingContract: (payload, cancelledBy, controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/${cancelledBy}/cancel`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  cancelBookingContractQuote: (payload, controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/guest/cancel/quote`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  readContractCancellation: (controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'GET',
      path: `/v1/contracts/${controlId}/current_and_previous`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  guestRequestQuote: (token, payload, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: '/v1/contracts/request/guest/quote',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  inquire: (payload, quote, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/inquiry/guest${quote ? '/quote' : ''}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  inquiryToRequest: (controlId, payload, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/inquiry/guest/convert`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  guestRequest: (payload, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: '/v1/contracts/request/guest',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  guestPaymentUpdate: (control_id, payload, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${control_id}/request/guest/update_payment_info`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  updateRequest: (payload, controlId, token, param, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/request/guest/${param}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  guestUpdateQuote: (payload, controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/update/guest/quote`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  createGuestSettleBalance: (payload, controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/update/guest/settle_balance`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  createGuestUpdate: (payload, controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/update/guest`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  updateGuestUpdate: (payload, controlId, token, action, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/update/guest/${action}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  readDuplicatePendingGuestRequests: (payload, guest_id, listing_id, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/guest/${guest_id}/listing/${listing_id}/count/pending`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  readCCAuthState: (controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'GET',
      path: `/v1/contracts/${controlId}/count/pending/auth`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  creditPaymentQuote: (payload, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: '/v1/contracts/payment/method/calc',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  updateToUnderReview: (payload, controlId, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${controlId}/review`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  overtimeQuote: (payload, control_id, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${control_id}/update/host/adjust/quote`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  createOvertime: (payload, control_id, token, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${control_id}/update/host/adjust`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    }, payload);
  },

  fetchSpaceRentalsInfo: (token, query, callback) => {
    const params = {
      host: contractsHost,
      method: 'GET',
      path: `/v1/contracts/space_rentals/info${query}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  },

  updateGuestBillingForOfferReview: (token, control_id, callback) => {
    const params = {
      host: contractsHost,
      method: 'POST',
      path: `/v1/contracts/${control_id}/offer/update_guest_billing`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(params, (res) => {
      callback(res);
    });
  }
};

module.exports = Contracts;
